import { getInitialSearchQPM } from "./ParamsManager";

type UrlQueryReader = ReturnType<typeof getInitialSearchQPM>;

export const getSeaReferenceFromUrl = (qpm: UrlQueryReader): string | null =>
  qpm.get("number") ?? qpm.get("container") ?? qpm.get("reference_number");

export const getSeaReferenceTypeFromUrl = (qpm: UrlQueryReader): string | null =>
  qpm.get("type") ?? qpm.get("reference_type");

export const getSeaCarrierCodeFromUrl = (qpm: UrlQueryReader): string | null =>
  qpm.get("sealine") ?? qpm.get("carrier_code");

export const getAirReferenceFromUrl = (qpm: UrlQueryReader): string | null =>
  qpm.get("number") ?? qpm.get("awb_number");
